export const SIGNUP_PHONE_STEP_JUST_SEEN_KEY = 'signup_phone_step_just_seen'

export function markSignupPhoneStepSeen(): void {
  if (typeof window === 'undefined') return
  try {
    window.sessionStorage.setItem(SIGNUP_PHONE_STEP_JUST_SEEN_KEY, '1')
  } catch {
    // sessionStorage can throw in private mode / disabled storage — swallow.
  }
}

export { useSignupPhoneStepJustSeen } from './use-signup-phone-step-just-seen'
